// // import _ from 'lodash'
// import Vue from 'vue'
// import Router from 'vue-router'
// // import store from '@/store'
// import { route_components, translated_routes } from '@/router/static_routes.js'
// import Meta from 'vue-meta'

// // -----------------------------------------------------------------------------

// function create_vue_router_routes() {
//   let res = []
//   for (const [language, mapping] of Object.entries(translated_routes)) {
//     for (const [canonical_route, translated_route] of Object.entries(mapping)) {
//       let tres = {
//         path: '/' + language + translated_route,
//         component: route_components[canonical_route],
//         pathToRegexpOptions: { strict: true },
//       }
//       res.push(tres)
//     }
//   }
//   res.push({
//     path: '/',
//     redirect: '/fr',
//     pathToRegexpOptions: { strict: true },
//   })
//   res.push({
//     path: '/essayer',
//     redirect: '/fr/contact',
//     pathToRegexpOptions: { strict: true },
//   })
//   res.push({
//     path: '*/',
//     redirect: to => {
//       let res = to.path.slice(0, -1)
//       if (res === '') {
//         res = '/'
//       }
//       return res
//     },
//     pathToRegexpOptions: { strict: true },
//   })
//   res.push({
//     path: '*',
//     // redirect: '/en',
//     redirect: to => {
//       // console.log('Redirecting', to.path, to)
//       let language = (to.path + '   ').slice(1, 3)

//       // if (language !== 'en' && language !== 'fr') {
//       //   language = store.state.language
//       //   if (!language) {
//       //     language = 'fr'
//       //   }
//       // }
//       // language = 'fr'
//       let res = '/' + language
//       // console.log(res)
//       return res
//     },
//     pathToRegexpOptions: { strict: true },
//   })
//   return res
// }

// Vue.use(Router)
// Vue.use(Meta, {
//   keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
//   attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
//   ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
//   tagIDKeyName: 'vmid', // the property name that vue-meta uses to determine whether to overwrite or append a tag
// })

// let router = new Router({
//   mode: 'history',
//   routes: create_vue_router_routes(),
// })

// // router.beforeEach((to, from, next) => {
// //   // console.log(to, from, next)
// //   let language = (to.path + "   ").slice(1, 3)
// //   if (language !== "en" && language !== 'fr') {
// //     language = store.state.language
// //     if (!language) {
// //       language = 'en'
// //     }
// //   }
// //   // console.log("commiting locale")
// //   // console.log(store)
// //   store.commit('update_locale', language)
// //   // console.log("locale committed")

// //   next()
// // })

// export default router

// import _ from 'lodash'
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { route_components, translated_routes } from '@/router/static_routes.js'
import Meta from 'vue-meta'

// -----------------------------------------------------------------------------

function create_vue_router_routes() {
  let res = []
  for (const [language, mapping] of Object.entries(translated_routes)) {
    for (const [canonical_route, translated_route] of Object.entries(mapping)) {
      let tres = {
        path: '/' + language + translated_route,
        component: route_components[canonical_route],
        pathToRegexpOptions: { strict: true },
      }
      res.push(tres)
    }
  }
  res.push({
    path: '/',
    redirect: '/fr',
    pathToRegexpOptions: { strict: true },
  })
  // res.push({
  //   path: '/essayer',
  //   redirect: '/fr/contact',
  //   pathToRegexpOptions: { strict: true },
  // })
  res.push({
    path: '*/',
    redirect: to => {
      let res = to.path.slice(0, -1)
      if (res === '') {
        res = '/'
      }
      return res
    },
    pathToRegexpOptions: { strict: true },
  })
  res.push({
    path: '*',
    // redirect: '/en',
    redirect: to => {
      // console.log('Redirecting', to.path, to)
      let language = (to.path + '   ').slice(1, 3)

      if (language !== 'en' && language !== 'fr') {
        language = store.state.language
        if (!language) {
          language = 'fr'
        }
      }
      // language = 'fr'
      let res = '/' + language
      // console.log(res)
      return res
    },
    pathToRegexpOptions: { strict: true },
  })
  return res
}

Vue.use(Router)
Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'vmid', // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

let router = new Router({
  mode: 'history',
  routes: create_vue_router_routes(),
})

router.beforeEach((to, from, next) => {
  // console.log(to, from, next)
  let language = (to.path + '   ').slice(1, 3)
  if (language !== 'en' && language !== 'fr') {
    language = store.state.language
    if (!language) {
      language = 'en'
    }
  }
  // console.log('commiting locale', language)
  // console.log(store)
  store.commit('update_locale', language)
  // console.log("locale committed")

  next()
})

export default router
